
import { IPerformanceIndicatorAnswer } from '@/interfaces/performance_indicator';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FilteredAnswer extends Vue {
  @Prop({ type: Object, default: () => {} }) readonly allItems: object;

  questions = [{ selectedAnswer: null }];

  isResults(question: any) {
    return Object.keys(this.filterAnswer(question.selectedAnswer)).length;
  }

  addQuestion() {
    this.questions.push({ selectedAnswer: null });
  }

  cleanItem(index: number) {
    if (this.questions.length > 1) {
      this.questions.splice(index, 1);
    } else {
      this.questions = [{ selectedAnswer: null }];
    }
  }

  shouldHideIcon(index: number) {
    return (index + 1) % 3 === 0;
  }

  filterAnswer(pq_id: number) {
    const items = this.allItems;
    const filteredAnswers: IPerformanceIndicatorAnswer = {};

    for (const nameAnswer in items) {
      const campaignAnswers = items[nameAnswer].filter((answer: any) => {
        return answer.performance_question_id === pq_id;
      });

      if (campaignAnswers.length > 0) {
        filteredAnswers[nameAnswer] = campaignAnswers;
      }
    }
    return filteredAnswers;
  }

  get nameAnswer() {
    const uniqueCompanyIds = new Set();
    let item = Object.values(this.allItems);
    for (const itemArray of item) {
      for (const item of itemArray) {
        uniqueCompanyIds.add({
          id: item.performance_question_id,
          answer: item.answer,
        });
      }
    }
    return Array.from(uniqueCompanyIds);
  }
}
